import { render } from "./BaseMenuView.vue?vue&type=template&id=108aab9c&scoped=true"
import script from "./BaseMenuView.vue?vue&type=script&lang=js"
export * from "./BaseMenuView.vue?vue&type=script&lang=js"

import "./BaseMenuView.vue?vue&type=style&index=0&id=108aab9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-108aab9c"]])

export default __exports__